import React from 'react'
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import UpdateIcon from '@mui/icons-material/Update'
import { convertLocalDateTimeToISO } from '../utils/dateUtils'

/**
 * Display last updated timestamp with prominent, readable formatting
 * @param {Array|string} updatedAt - LocalDateTime array or ISO string
 * @param {boolean} isInModal - Whether component is in modal
 */
const LastUpdatedDisplay = ({ updatedAt, isInModal = false }) => {
  const theme = useTheme()
  const isXSmall = useMediaQuery(theme.breakpoints.down('sm'))
  if (!updatedAt) return null

  // Convert LocalDateTime array to formatted date
  const getFormattedDate = () => {
    try {
      // If it's already an ISO string
      if (typeof updatedAt === 'string') {
        const date = new Date(updatedAt)
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: isXSmall ? 'short' : 'long',
          day: 'numeric',
        })
      }

      // If it's a LocalDateTime array
      const isoString = convertLocalDateTimeToISO(updatedAt)
      if (!isoString) return null

      const date = new Date(isoString)
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: isXSmall ? 'short' : 'long',
        day: 'numeric',
      })
    } catch (error) {
      console.error('Error formatting date:', error)
      return null
    }
  }

  const formattedDate = getFormattedDate()
  if (!formattedDate) return null

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        // paddingX: 2,
        // paddingTop: 1.5,
        // paddingBottom: isInModal ? 1.5 : 2.5,
        // gap: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 0.5, sm: 1, md: 1.5 },
          paddingX: { xs: 1, sm: 1.5, md: 2 },
          paddingY: { xs: 0.75, sm: 1, md: 1.5 },
          backgroundColor: 'rgba(248, 249, 250, 0.98)',
          borderRadius: { xs: '6px', md: '8px' },
          border: '1px solid rgba(233, 236, 239, 0.8)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <UpdateIcon
          sx={{
            fontSize: { xs: '0.875rem', sm: '1rem', md: '1.25rem' },
            color: '#232536',
            flexShrink: 0,
          }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column', // Stack vertically
            gap: 0.25,
          }}
        >
          <Typography
            variant='body2'
            sx={{
              fontWeight: 600,
              fontSize: { xs: '0.625rem', sm: '0.75rem', md: '0.875rem' },
              color: '#495057',
              letterSpacing: '0.01em',
              lineHeight: 1.1,
              whiteSpace: 'nowrap',
            }}
          >
            Website Last updated:
          </Typography>
          <Typography
            variant='body2'
            sx={{
              fontWeight: 700,
              fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.9rem' },
              color: '#232536',
              letterSpacing: '-0.01em',
              lineHeight: 1.1,
              whiteSpace: 'nowrap',
            }}
          >
            {formattedDate}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default LastUpdatedDisplay
